export default __webpack_public_path__ + "static/media/misc-bathtubA-480w.f5589e74.webp";